import React, { useEffect, useState } from "react";

import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import { setInsuranceList } from "../../../../infra/aggregates/myProfile/insuranceAggregates/insuranceListSlice";
import { setExpiredInsuranceList } from "../../../../infra/aggregates/myProfile/insuranceAggregates/expiredInsuranceSlice";

import toast from "react-hot-toast";
import { insuranceServices } from "../../../../api/services/insuranceServices";
import _ from "lodash";
import EditInsurancePresenter from "./EditInsurancePresenter";
import DTOEditInsurance from "./DTOEditInsurance";
import { dependentsServices } from "../../../../api/services/dependentsServices";
import { setAlldependentslist } from "../../../../infra/aggregates/myProfile/DependentsAggregates/dependentslistSlice";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  editedData: any;
  mainModel: any;
  trans?: any;
}

const EditInsuranceController = ({
  isModalOpen,
  closeModal,
  editedData,
  mainModel,
  trans,
}: ModalInterface) => {
  const selector = useAppSelector((state) => state.authSlice);

  const [allInsurers, setAllInsurers] = useState([]);
  const [allPolicies, setAllPolicies] = useState([]);

  const dispatch = useAppDispatch();

  const getData = (data: any) => {
    console.log("getData----", data);
    editInsurance(data);
  };

  const callBackGetInsurerTypes = (data: any) => {
    setAllInsurers(data);
  };
  const callBackGetPolicyTypes = (data: any) => {
    setAllPolicies(data);
  };

  async function editInsurance(data: any) {
    if (selector && data) {
      const empId: any = selector.emp_id;
      const formData: any = new FormData();

      formData.append("emp_id", empId);
      formData.append("id", data.id);
      formData.append("dependent_id", editedData?.dependent_id);
      formData.append("insurer", data.insurer);
      formData.append("policy_type", data.policy_type);
      formData.append("policy_number", data.policy_number);
      formData.append("start_date", data.start_date);
      formData.append("end_date", data.end_date);
      formData.append("category", data.category);
      formData.append("amount", data.amount);
      formData.append("removed", data?.removed);
      if (data.newattachement) {
        formData.append("attachments", data.attachments);
      }

      formData.append("locale", localStorage.getItem("emplang"));

      await dependentsServices
        .editInsurance(formData)
        .then((response) => {
          if (response.response == "success") {
            dispatch(setAlldependentslist(response.data));
            toast.success(trans("Insurance Updated Successfully"));
            mainModel(false);
          }
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
        });
    }
  }

  return (
    <div>
      <DTOEditInsurance
        setAllInsurerTypesData={callBackGetInsurerTypes}
        setAllPolicyTypesData={callBackGetPolicyTypes}
      />

      <EditInsurancePresenter
        callBackGetData={getData}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        allInsurerTypes={allInsurers}
        allPolicyTypes={allPolicies}
        editedData={editedData}
        trans={trans}
      />
    </div>
  );
};

export default EditInsuranceController;
